import {GetAdDetailsError} from './GetAdDetailsError.js'
import {GetAdDetailsGenericError} from './GetAdDetailsGenericError.js'
import {GetAdDetailsNotFoundError} from './GetAdDetailsNotFoundError.js'
import {GetAdDetailsPartialContentError} from './GetAdDetailsPartialContentError.js'
import {GetFinancingDataAdsError} from './GetFinancingDataAdsError.js'
import {GetInstantOfferAdsError} from './GetInstantOfferAdsError.js'
import {GetInstantOfferGenericAdsError} from './GetInstantOfferGenericAdsError.js'
import {GetInstantOfferNotFoundAdsError} from './GetInstantOfferNotFoundAdsError.js'
import {GetRecommendedAdsGenericError} from './GetRecommendedAdsGenericError.js'
import GetSearchDataFromUrlError from './GetSearchDataFromUrlError.js'
import GetSearchRequestObjectFromUrlError from './GetSearchRequestObjectFromUrlError.js'
import GetSearchResultsError from './GetSearchResultsError.js'
import {GetSearchStatsGenericError} from './GetSearchStatsGenericError.js'
import {GetSubscriptionCommitmentOptionsAdsError} from './GetSubscriptionCommitmentOptionsAdsError.js'
import {GetSubscriptionSearchResultsAdsError} from './GetSubscriptionSearchResultsAdsError.js'
import {GetSubscriptionSearchResultsInvalidRequestAdsError} from './GetSubscriptionSearchResultsInvalidRequestAdsError.js'
import InvalidRequestError from './InvalidRequestError.js'
import InvalidSearchRequestError from './InvalidSearchRequestError.js'
import {MotosNotImplementedError} from './MotosNotImplementedError.js'
import RelatedAdsError from './RelatedAdsError.js'
import ReportAdError from './ReportAdError.js'

export default class AdsErrorsFactory {
  static invalidRequestError = () => new InvalidRequestError()

  static reportAdError = () => new ReportAdError()

  static relatedAdsError = message => new RelatedAdsError(message)

  static invalidSearchRequestError = message => new InvalidSearchRequestError(message)

  static getAdDetailsGenericError = ({message, status, origin}) =>
    new GetAdDetailsGenericError({message, status, origin})

  static getAdDetailsError = message => new GetAdDetailsError(message)

  static getAdDetailsNotFoundError = ({message, status, origin}) =>
    new GetAdDetailsNotFoundError({message, status, origin})

  static getInstantOfferAdsError = message => new GetInstantOfferAdsError(message)

  static getInstantOfferGenericAdsError = message => new GetInstantOfferGenericAdsError(message)

  static getInstantOfferNotFoundAdsError = message => new GetInstantOfferNotFoundAdsError(message)

  static getSearchDataFromUrlError = () => new GetSearchDataFromUrlError()

  static getSearchRequestObjectFromUrlError = () => new GetSearchRequestObjectFromUrlError()

  static getSearchResultsError = () => new GetSearchResultsError()

  static motosNotImplementedError = () => new MotosNotImplementedError()

  static getSubscriptionCommitmentOptionsAdsError = message => new GetSubscriptionCommitmentOptionsAdsError()

  static getSubscriptionSearchResultsAdsError = message => new GetSubscriptionSearchResultsAdsError(message)

  static getSubscriptionSearchResultsInvalidRequestAdsError = () =>
    new GetSubscriptionSearchResultsInvalidRequestAdsError()

  static getAdDetailsPartialContentError = ({adId, message, status, origin}) =>
    new GetAdDetailsPartialContentError({adId, message, status, origin})

  static getFinancingDataAdsError = message => new GetFinancingDataAdsError(message)

  static getSearchStatsGenericError = message => new GetSearchStatsGenericError(message)

  static getRecommendedAdsGenericError = message => new GetRecommendedAdsGenericError(message)
}
